import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import cn from './cn.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { cn: { translation: cn }, en: { translation: en } },
    fallbackLng: 'cn',
    supportedLngs: ['cn', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: 'gendent.lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
